import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PrintingOnType } from 'src/app/shared/enums/printing-on-type.enum';
import { SettingsService } from 'src/app/shared/data-service/settings.service';
import { SettingsKey } from 'src/app/core/store/settings-config.keys';
import { PrintSampleBarcodeService } from './print-sample-barcode.service';
import { StoreService } from 'projects/dop-core/src/public-api';
import { StoreKey } from 'src/app/core/store/ngrx-store.keys';
import { ReportTemplate } from 'src/app/shared/models/report-template.model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-print-sample-barcode',
  templateUrl: './print-sample-barcode.component.html',
  styleUrls: ['./print-sample-barcode.component.scss'],
  providers: [PrintSampleBarcodeService]
})
export class PrintSampleBarcodeComponent implements OnInit {

  sampleBarcodeGroup: FormGroup;
  printingOnType = PrintingOnType;
  enableSmartLabelPrinting = false;
  reportTemplateValues: SelectItem[] = [];
  printingOn = PrintingOnType.CONTAINING;

  constructor(
    private fb: FormBuilder,
    public ref: DynamicDialogRef,
    private settingsService: SettingsService,
    private printSampleBarcodeService: PrintSampleBarcodeService,
    private storeService: StoreService
  ) { }

  async ngOnInit(): Promise<void> {
    this.sampleBarcodeGroup = this.printSampleBarcodeService.initiate(this.fb);
    this.setReportTemplateValues();
    this.enableSmartLabelPrinting = (await this.settingsService.getSettingValue(SettingsKey.EnableSmartLabelPrinting)
    ).toLowerCase() === 'true';
  }

  setReportTemplateValues() {
    this.storeService.Get(StoreKey.ReportTemplates).toPromise().then((data: ReportTemplate[]) => {
      if (!data) {
        this.printSampleBarcodeService.getReportTemplates().then(x => {
          this.storeService.Save(StoreKey.ReportTemplates, x, true);
          this.setReportTemplates(x);
        });
      } else {
        this.setReportTemplates(data);
      }
    });
  }

  setReportTemplates(data: ReportTemplate[]) {
    data.forEach(x => {
      this.reportTemplateValues.push({
        label: x.name,
        value: x.code
      });
    });
    this.reportTemplate.setValue(this.reportTemplateValues[0].value);
    this.printSampleBarcodeService.currentOrder.printingServiceCode = this.reportTemplate.value;
  }

  onNoOfBarcodeUpdate(event: number) {
    this.printSampleBarcodeService.updateSampleCount(event);
  }

  onDownloadBarCodeClick() {
    if (this.sampleBarcodeGroup.valid || this.printingOn === this.printingOnType.EMPTY || !this.enableSmartLabelPrinting) {
      this.printSampleBarcodeService.downloadSampleBarcodes(this.enableSmartLabelPrinting);
    }
  }

  updatePrintingOn(printingOn: PrintingOnType) {
    this.printingOn = printingOn;
    this.sampleBarcodeGroup.get('printingOn').setValue(printingOn);
  }

  onReportTemplateChange() {
    this.reportTemplate.setValue(this.reportTemplate.value);
    this.printSampleBarcodeService.currentOrder.printingServiceCode = this.reportTemplate.value;
  }

  get reportTemplate() {
    return this.sampleBarcodeGroup.get('reportTemplate');
  }

}
